const context = require.context('@/modules', true, /.*Repository\.js$/);
const modules = {};

context.keys().forEach((file) => {
  const fileArr = file.replace(/(\.\/|\/index\.js$)/g, '').split('/');
 const moduleName = fileArr[fileArr.length - 1];
  modules[moduleName.substr(0, moduleName.indexOf('Repository.js'))] =
    context(file).default || context(file);
});

const repositories = {
  ...modules,
};

export const RepoFactory = {
  get: (name) => repositories[name],
};
